module.exports = __webpack_public_path__ + "static/img/Ben-Kennedy.db3b44f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Kennedy.jpg
// module id = x28q
// module chunks = 0